import { http } from 'services/BaseApi';
import { SsoResponse } from 'types/SsoResponse';

export const kaiserSso = async (userId: string): Promise<SsoResponse> => {
  return await http.get<string>(`/peoplenet/${userId}`);
};
